// Vatar mode: the build that runs inside the Lagos Life Games frame.
// vatar.html sets <html data-vatar="1"> before any script runs, so this is
// true for the whole Vatar bundle and false for the normal site.
export const IS_VATAR =
  typeof document !== 'undefined' && document.documentElement.dataset.vatar === '1';

// Where "home" is: the Vatar build lives under /vatar on the same host.
export const HOME_PATH = IS_VATAR ? '/vatar' : '/';
